define.alias("ember-composable-helpers/helpers/queue", "calendar/helpers/queue");